import { render, staticRenderFns } from "./gzhConfigTemplate.vue?vue&type=template&id=3708f855&scoped=true"
import script from "./gzhConfigTemplate.vue?vue&type=script&lang=js"
export * from "./gzhConfigTemplate.vue?vue&type=script&lang=js"
import style0 from "./gzhConfigTemplate.vue?vue&type=style&index=0&id=3708f855&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708f855",
  null
  
)

export default component.exports